import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MatToolbarModule} from "@angular/material/toolbar";
import {TranslateService} from "@ngx-translate/core";
import {TranslationService} from "./core/services/translation.service";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, MatToolbarModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(translate: TranslateService,
              translationService: TranslationService) {
    translate.setDefaultLang('ru');
    translate.use('ru');
  }
}
